import { EBaseApiTags } from 'shared/typings';

import { enhancedApi } from './codegen.api';

export const channelsApi = enhancedApi.enhanceEndpoints({
	addTagTypes: [EBaseApiTags.CHANNELS, EBaseApiTags.CHANNEL],
	endpoints: {
		channelsList: {
			providesTags: [EBaseApiTags.CHANNELS],
		},
		channelsRetrieve: {
			providesTags: [EBaseApiTags.CHANNEL],
		},
		channelsUpdate: {
			invalidatesTags: (_, error) => (error ? [] : [EBaseApiTags.CHANNELS, EBaseApiTags.CHANNEL]),
		},
		channelsPartialUpdate: {
			invalidatesTags: (_, error) => (error ? [] : [EBaseApiTags.CHANNELS, EBaseApiTags.CHANNEL]),
		},
		channelsDestroy: {
			invalidatesTags: (_, error) => (error ? [] : [EBaseApiTags.CHANNELS]),
		},
	},
});

export const {
	useChannelsListQuery,
	useChannelsRetrieveQuery,
	useChannelsUpdateMutation,
	useChannelsPartialUpdateMutation,
	useChannelsDestroyMutation,
} = channelsApi;
